import { faArrowDown, faArrowUp, faPlusCircle, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Table, Button, Form, Row, Col } from 'react-bootstrap';
import 'antd/dist/antd.css'
import { Select } from 'antd'
import axios from 'axios';
import api from '../../config.json'
import swal from 'sweetalert';

const MoveableTable = ({ handleOnChange, reportData }) => {
    const [rows, setRows] = useState([]);
    const [errors, setErrors] = useState({})
    const [newRowName, setNewRowName] = useState('');
    const CustomDataTypes = [
        {
            label: 'User Input Number',
            value: 'UserInputNumber'
        },
        {
            label: 'User Input Decision',
            value: 'UserInputDecision'
        },
        {
            label: 'User Input String',
            value: 'UserInputString'
        },
        {
            label: 'Constant String',
            value: 'ConstantString'
        },
        // {
        //     label: 'Input From List',
        //     value: 'InputFromList'
        // },
        {
            label: 'Standard Dimension',
            value: 'StandardDimension'
        },
        {
            label: 'Dimension ( + ) Tolerance',
            value: 'Dimension+Tolerance'
        },
        {
            label: 'Dimension ( - ) Tolerance',
            value: 'Dimension-Tolerance'
        },
        {
            label: 'Image',
            value: 'Image'
        }
    ];


    useEffect(() => {
        setRows(reportData.Columns || []);
    }, [reportData])





    const moveRowUp = (index) => {
        if (index === 0) return; // Can't move up the first row
        const newRows = [...rows];
        [newRows[index - 1], newRows[index]] = [newRows[index], newRows[index - 1]];
        handleOnChange({ target: { name: "Columns", value: newRows } })
        setRows(newRows);
    };

    const moveRowDown = (index) => {
        if (index === rows.length - 1) return; // Can't move down the last row
        const newRows = [...rows];
        [newRows[index + 1], newRows[index]] = [newRows[index], newRows[index + 1]];
        handleOnChange({ target: { name: "Columns", value: newRows } })
        setRows(newRows);
    };

    const addRow = () => {
        const newRow = { FieldName: "", DataType: "" };
        setRows([...rows, newRow]);
        setNewRowName('');
    };

    const deleteRow = (index) => {
        const newRows = rows.filter((row, i) => i !== index);
        handleOnChange({ target: { name: "Columns", value: newRows } })
        setRows(newRows);
    };

    const handleInputChange = (index, event) => {
        const data = [...rows];
        if(event.target.name=="Primary"){
            data.forEach(x=>{
                x.Primary=false;
            })
        }
        data[index][event.target.name] = event.target.value;
        if(data[index] &&  data[index].DataType && data[index].DataType.startsWith('UserInput')){
            data[index]["EnableForDataEntry"] = true; 
        }
        handleOnChange({ target: { name: "Columns", value: data } })
        setRows(data);
    }



    return (
        <div>
            <Form>
                <Row className="mt-3">
                    <Col sm={2} className='mt-2'>
                        <strong>Template Name</strong>
                    </Col>
                    <Col sm={4}>
                        <input className='form-control form-control-sm' value={reportData.Name || ""} type='text' placeholder='Enter template name...' onChange={(e) => handleOnChange({ target: { name: 'Name', value: e.currentTarget.value } })} />
                    </Col>

                </Row>
            </Form>
            <Table className='mt-2' striped bordered hover>
                <thead>
                    <tr className='text-center'>
                        <th>Field</th>
                        <th>Data Type</th>
                        <th>Display When Entering Data</th>
                        <th>Primary</th>
                        <th>Position</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, index) => (
                        <tr className='text-center' key={row.id}>
                            <td>
                                <div className='form-group form-group-sm'>
                                    <input disabled={row.DataType=="None"} style={{ width: '60%' }} className='form-control form-control-sm' value={row.FieldName || ""} type='text'
                                        placeholder='enter field name...' onChange={(e) => handleInputChange(index, { target: { name: 'FieldName', value: e.currentTarget.value } })} />
                                </div>
                                {errors.FieldName && <div className="alert small alert-danger">{errors['FieldName']}</div>}
                            </td>
                            <td>
                                <Select
                                    // maxTagCount='responsive'
                                    //mode="multiple"
                                    disabled={row.DataType=="None"}
                                    placeholder="Select Data Type"
                                    value={row.DataType || []}
                                    onChange={(values, all) => {
                                        handleInputChange(index, { target: { name: 'DataType', value: values } })
                                    }}
                                    style={{ width: '100%' }}
                                    options={CustomDataTypes}
                                />

                            </td>
                            <td><input disabled={row.DataType=="None"|| (row.DataType && row.DataType.startsWith("UserInput"))} className='mt-2' checked={row.EnableForDataEntry || false} type='checkbox' onChange={(e) => handleInputChange(index, { target: { name: 'EnableForDataEntry', value: e.currentTarget.checked } })} name='EnableForDataEntry' /></td>
                            <td><input   className='mt-2' checked={row.Primary || false} type='radio' onChange={(e) => handleInputChange(index, { target: { name: 'Primary', value: e.currentTarget.checked } })} name="Primary" /></td>
                            <td>
                                <Button
                                    variant="secondary"
                                    size="sm"
                                    onClick={() => moveRowUp(index)}
                                    disabled={index === 0}
                                >
                                    <FontAwesomeIcon icon={faArrowUp} />
                                </Button>{' '}
                                <Button
                                    variant="secondary"
                                    size="sm"
                                    onClick={() => moveRowDown(index)}
                                    disabled={index === rows.length - 1}
                                >
                                    <FontAwesomeIcon icon={faArrowDown} />
                                </Button>{' '}
                            </td>
                            <td>
                                {rows.length > 1 && <Button
                                    variant="danger"
                                    size="sm"
                                    onClick={() => deleteRow(index)}
                                >
                                    <FontAwesomeIcon icon={faTrashAlt} />
                                </Button>}
                                {(index == rows.length - 1) && <Button
                                    className='ml-1'
                                    // variant="danger"
                                    size="sm"
                                    onClick={() => addRow()}
                                >
                                    <FontAwesomeIcon icon={faPlusCircle} />
                                </Button>}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default MoveableTable;
